

module.exports = {
    api: process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : 'https://shrouded-plateau-06981.herokuapp.com'
}